import { useEffect, useState } from "react";
import axios from "axios";
import { axiosConfig } from "../Helpers/AxiosRequest";
import WeatherIcon from "./WeatherIcon";
import { API_URL } from "../Helpers/api";

function WeatherWidget() {
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    axios(axiosConfig("GET", `${API_URL}/weather`))
      .then(({ data }) => {
        if (data.success) setWeather(data);
      })
      .catch((err) => console.error(err.message));
  }, []);

  return (
    <div
      className={`z-3 p-1 rounded ${!weather ? "d-none" : ""}`}
      style={{
        fontSize: "0.8rem",
        backgroundColor: "rgba(0,0,0,.2)",
        height: "100%",
      }}
    >
      {weather && (
        <>
          {weather ? (
            <>
              <WeatherIcon weather={weather} />
              <div className="my-auto">
                <p className="mb-1">{Math.round(weather.main.temp)}°C</p>
              </div>
            </>
          ) : (
            <div>
              <div>-</div>
              <div>-</div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default WeatherWidget;
